import React, { ComponentType, JSX } from 'react'

export function ConditionalWrapper<T>({
  condition,
  Wrapper,
  children,
  props,
}: {
  Wrapper: ComponentType<T> | keyof JSX.IntrinsicElements
  children: React.ReactNode
  condition: boolean
  props?: Omit<T, 'children'>
}): JSX.Element {
  return condition ? (
    <Wrapper {...(props as T)}>{children}</Wrapper>
  ) : (
    <>{children}</>
  )
}
